import { apiClient } from '@/lib/api';
export const domainsApi = {
    list: (orgId) => apiClient.get(`/sslwidewatch/domainByOrg/${orgId}`),
    add: (body) => apiClient.post(`/sslwidewatch/addDomain`, body),
    update: (id, body) => apiClient.put(`/sslwidewatch/updateDomain/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/deleteDomain/${id}`),
};
/**
 * SSL domain-groups API. Routes match the backend SslDomainGroupController
 * under /sslwidewatch/domain-groups. No orgId in path — tenant resolved from JWT.
 */
export const domainGroupsApi = {
    list: () => apiClient.get('/sslwidewatch/domain-groups'),
    get: (id) => apiClient.get(`/sslwidewatch/domain-groups/${id}`),
    create: (body) => apiClient.post('/sslwidewatch/domain-groups', body),
    update: (id, body) => apiClient.patch(`/sslwidewatch/domain-groups/${id}`, body),
    remove: (id) => apiClient.delete(`/sslwidewatch/domain-groups/${id}`),
    // Membership management from the group editor.
    members: (groupId) => apiClient.get(`/sslwidewatch/domain-groups/${groupId}/members`),
    addMember: (groupId, domainId) => apiClient.post(`/sslwidewatch/domain-groups/${groupId}/members/${domainId}`, {}),
    /** Bulk-add: pass several domain ids in one request. */
    addMembers: (groupId, domainIds) => apiClient.post(`/sslwidewatch/domain-groups/${groupId}/members`, { domainIds }),
    removeMember: (groupId, domainId) => apiClient.delete(`/sslwidewatch/domain-groups/${groupId}/members/${domainId}`),
};
/** Alert Groups list — cross-product recipient bundles (read-only here). */
export const alertGroupsListApi = {
    list: () => apiClient.get('/sslwidewatch/alerts/groups'),
};
